import { useAllPrismicDocumentsByType } from '@prismicio/react';
import { LinksSection } from 'modules/landing/components/links-section';
import React from 'react';

export const WhatOthersSayAboutUs: React.FunctionComponent = () => {
  const [document] = useAllPrismicDocumentsByType('about_us');

  if (!document) {
    return null;
  }

  const [
    {
      data: { media },
    },
  ] = document;

  const links = media.map(({ title, date, link_text, link }: any) => ({
    id: title,
    title,
    date: new Date(date),
    link: { text: link_text, url: link.url },
  }));

  return <LinksSection title="What others say about us" links={links} />;
};
